import React from 'react';

import isEmpty from 'lodash.isempty';
import {EventReviewFeedback} from 'src/modules/ai';
import {EVENT_SOURCE_FIELD_NAME} from 'src/modules/ai/constants';
import {EventCreationMode, HeaderFields} from 'src/modules/event-create/constants';
import {EVENT_SOURCE_INFO} from 'src/modules/event-create/event-create-hovers';
import {HeaderBlock} from 'src/modules/event-create/typedefs';
import {eventSourceValidation} from 'src/modules/event-create/validations/event-source-validation';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';
import {Loading, Types} from '@pb/kit-component-loading';

type Props = {
    eventsInfo: EventBasicInfo[],
    sourcesList: string[],
    changeRequestId: number | null,
    headerValues: HeaderBlock,
    mode: EventCreationMode,
    validationHighLight: boolean,
    onChangeField: (value: string, name?: string) => void,
};

export const EventSource = (props: Props) => {
    const {
        eventsInfo,
        sourcesList,
        headerValues,
        mode,
        changeRequestId,
        validationHighLight,
        onChangeField,
    } = props;

    const hasValidationError =
        Boolean(validationHighLight && eventSourceValidation(headerValues.source).length);

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group gap="xs" alignItems="center" justify="start">
                <strong>Event Source:</strong>
                <Dropdown
                    hoverEnabled={true}
                    clickEnabled={false}
                    maxWidth={500}
                    anchor={({anchorRef, getAnchorProps}) => (
                        <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                    )}>
                    {EVENT_SOURCE_INFO}
                </Dropdown>
                {mode === EventCreationMode.create && (
                    <EventReviewFeedback
                        changeRequestId={changeRequestId}
                        fieldName={EVENT_SOURCE_FIELD_NAME}
                    />
                )}
            </Group>
            <Group alignItems="center">
                <Item style={{width: '100%'}}>
                    <ComboBox
                        placeholder="Event Source"
                        color={hasValidationError ? 'ERROR' : 'DEFAULT'}
                        name={HeaderFields.eventSource}
                        value={headerValues.source}
                        disabled={mode === EventCreationMode.update}
                        onChange={onChangeField}>
                        {sourcesList.map(source =>
                            <ComboboxItem key={source} value={source} caption={source}/>,
                        )}
                    </ComboBox>
                </Item>
                <Item style={{width: '1rem'}}>
                    {isEmpty(eventsInfo) && (
                        <Loading fast={true} type={Types.ICON}/>
                    )}
                </Item>
            </Group>
        </Group>
    );
};
